import Picker, { type EmojiClickData } from "emoji-picker-react";

import styles from "./live-chat.module.css";

import { ActionIcon, Center, Input, Stack, Text } from "@mantine/core";
import { useForm } from "@mantine/form";
import { Messages, Send2 } from "iconsax-react";
import { useState } from "react";

export function LiveChat() {
  const form = useForm({
    initialValues: {
      message: "",
    },
  });

  const [messages, setMessages] = useState<string[]>([]);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  const header = (
    <Stack align="center">
      <Text fw={600} fz={18} inherit>
        Live Chat
      </Text>
      <Text fz={14} inherit opacity={0.6}>
        Messages from the team will be shown here.
      </Text>
    </Stack>
  );

  const emptyContent = (
    <Center h="100%">
      <Stack align="center" c="#686161" maw={288}>
        <Messages color="#686161" size={40} variant="Outline" />
        <Text fw="bold" fz={14} ta="center">
          Messages from the team will be shown here
        </Text>
      </Stack>
    </Center>
  );

  const handleEmojiSelect = (emojiData: EmojiClickData) => {
    const message = form.values.message;
    form.setFieldValue("message", message + emojiData.emoji);
    setShowEmojiPicker(false);
  };

  const handleSendMessage = () => {
    if (form.values.message.trim()) {
      setMessages((prevMessages) => [...prevMessages, form.values.message]);
      form.setFieldValue("message", "");
    }
  };

  const messageInput = (
    <Stack mt={20}>
      <Input
        classNames={{
          wrapper: styles.wrapper,
          input: styles.input,
        }}
        onChange={(event) =>
          form.setFieldValue("message", event.currentTarget.value)
        }
        placeholder="Type a Message"
        rightSection={
          <ActionIcon
            bg="#e2261c"
            color="#e2261c"
            onClick={handleSendMessage}
            radius={4}
            size={35}
            variant="filled"
          >
            <Send2 color="#FFFFFF" size={20} variant="Bold" />
          </ActionIcon>
        }
        value={form.values.message}
      />
      {showEmojiPicker && (
        <div style={{ marginTop: "8px" }}>
          <Picker onEmojiClick={handleEmojiSelect} />
        </div>
      )}
    </Stack>
  );

  return (
    <div className={styles.container}>
      {header}
      <Stack
        p="md"
        style={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Stack style={{ overflowY: "auto", flexGrow: 1, width: "100%" }}>
          <div>{emptyContent}</div>
          {messages.map((msg) => (
            <Text key={msg} mb="xs">
              {msg}
            </Text>
          ))}
        </Stack>
        {messageInput}
      </Stack>
    </div>
  );
}
